import styled, {keyframes} from "styled-components";
import {dialogHighlightedTextMixin} from "../../../modal-dialog/boxes/text/dialog-text.box";

const firstTitleAnimation = keyframes`
    0%, 46% {
        opacity: 1;
        transform: translateY(0%) scale(1);
    }
    54%, 100% {
        opacity: 0;
        transform: translateY(-100%) scale(0.8);
    }
`;

const secondTitleAnimation = keyframes`
    0%, 46% {
        opacity: 0;
        transform: translateY(+50%) scale(0.8);
    }
    54%, 100% {
        opacity: 1;
        transform: translateY(-50%) scale(1);
    }
`;

export const JackpotToastTitleAnimatedDefaultBox = styled.div`
    ${dialogHighlightedTextMixin};
    width: 100%;
    text-align: center;
    font-size: 1.6rem;
    line-height: 1.1;
    padding: 0.5rem 0;
    &:nth-child(1) {
        opacity: 1;
        animation: ${firstTitleAnimation} 5s ease-in-out forwards infinite alternate 2.5s;
    }
    &:nth-child(2) {
        position: absolute;
        opacity: 0;
        top: 50%;
        transform: translateY(+50%) scale(0.1);
        animation: ${secondTitleAnimation} 5s ease-in-out forwards infinite alternate 2.5s;
    }
`;
